<template>
    <div id="dashboard" class="p-2 p-md-5 page">
        <transition name="fade" mode="out-in" >
            <div class="row" v-if="isParent">
                <div class="col-md-8">
                    <search v-on:add="addProfessional" @filters="setFilters"></search>
                </div>
                <div class="col-md-4">
                    <div class="card text-center mb-3 invisible-sm shadow">
                        <div class="card-body">
                            <div class="pt-5 pl-5 pr-5 text-center vert-center">
                                <img :src="profileImage" class="img-fluid img-thumbnail rounded-circle img-profile mx-auto" />
                            </div>
                            <h3 class="mt-5 mb-5">{{user.company}}</h3>
                            <div class="alert alert-success" role="alert" v-if="status == 2">
                                <strong>Goedgekeurd!</strong>
                            </div>
                            <div class="alert alert-warning" role="alert" v-else-if="status == 1">
                                <strong>In afwachting van goedkeuring!</strong>
                            </div>
                            <div class="alert alert-danger" role="alert" v-else-if="status == 3">
                                <strong>Afgekeurd!</strong>.
                            </div>
                        </div>
                    </div>
                    <div class="card text-center shadow">
                        <div class="card-header text-left">
                             <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-0 mt-2">Groepsaanvraag</h5>
                                <div v-if="professionals.length > 0">
                                    <button class="btn" @click="professionals = []"><font-awesome-icon icon="trash-alt" /></button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <h5 v-if="professionals.length == 0" class="text-muted mt-5 mb-5">De groepsaanvraag is nog leeg...</h5>
                            <ul class="list-group text-left" v-else>
                                <li class="list-group-item" v-for="p in professionals" :key="p.id">
                                    <div class="d-flex w-100 justify-content-between">
                                        <h5 class="mb-1">
                                            <router-link tag="a" to="#">{{p.firstName}}</router-link>
                                            <button class="btn mr-2" @click="removeProfessional(p)"><font-awesome-icon icon="trash-alt" /></button>
                                        </h5>
                                        <small><small>v.a.</small> € {{p.dayRate.toFixed(2)}}<sup>*</sup></small>
                                            
                                    </div>
                                    <p class="mb-0">Inhuren op:&nbsp;
                                        <span class="badge badge-pill badge-secondary mr-1" @click="removeDate(p, d)" v-for="d in p.availableDates" :key="d">{{new Date(d).toLocaleDateString()}}</span>
                                    </p>
                                </li>
                            </ul>
                            <div v-if="professionals.length > 0" class="mt-3 text-right">
                                <router-link tab="button" class="btn btn-azure" :to="{ name: 'ClientRequest'}">Naar de aanvraag</router-link>
                                <button class="btn" @click="professionals = []"><font-awesome-icon icon="trash-alt" /></button>
                                <div class="text-center mt-3 mb-0">
                                    <small >Klik de datum om deze te verwijderen.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <assignment-modal :professionals="professionals" :show="showAssignmentModal" :group="true" @close="showAssignmentModal = false"></assignment-modal>
                <vue-toastr ref="toastr"></vue-toastr>
            </div>
            <router-view v-else></router-view>
        </transition>         
    </div>
</template>

<script>
import VueToastr from "vue-toastr";
import Search from '@/components/Search';
import AssignmentModal from '@/components/AssignmentModal';
export default {
    components: {
        Search,
        AssignmentModal,
        VueToastr
    },
    data() {
        return {
            professionals: [],
            showAssignmentModal: false,
            filters: null
        }
    },
    mounted() {
    },
    methods: {
        setFilters(f)
        {
            this.filters = f;
        },
        addProfessional(p) {
            if(p.availableDates.length == 0)
                return;

            if(!this.professionals.some((i) => i.id == p.id))
            {
                let clone = JSON.parse(JSON.stringify(p));
                this.professionals.push(clone);
                this.$refs.toastr.defaultPosition = "toast-bottom-right";
                this.$refs.toastr.s(
                    clone.firstName + " is toegevoegd aan de groepsaanvraag."
                );
            }
        },
        removeProfessional(p) {
            this.professionals.splice(this.professionals.indexOf(p), 1);
        },
        removeDate(p, d)
        {
            p.availableDates.splice(p.availableDates.indexOf(d), 1);
            if(p.availableDates.length == 0)
            {
                this.professionals.splice(this.professionals.indexOf(p), 1);
            }
        },
    },
    computed: {
        isParent() {
            if(this.$route.name.toLowerCase() == "clientdashboard" || this.$route.name.toLowerCase() == "client")
                return true;
            return false;
        },
        user() {
            return this.$store.getters.user;
        },
        profileImage() {
            if(this.user)
                return "data:" + this.user.profileImage.fileContentType + ";base64," + this.user.profileImage.file;
            return null;
        },
        status() {
            return this.user.profileStatusId;
        }
    }
}
</script>

<style scoped>
.badge {
    cursor: pointer;
}
</style>